export const dispatchVacancyPublished = (): void => {
    window.dispatchEvent(new CustomEvent('vacancyPublished'));
};

export const dispatchVacancyClosed = (): void => {
    window.dispatchEvent(new CustomEvent('vacancyClosed'));
};

let _bypassBeforeUnload = false;

export const bypassBeforeUnload = (): void => {
    _bypassBeforeUnload = true;
};

export const isBypassBeforeUnload = (): boolean => _bypassBeforeUnload;
